import {
  reactExtension,
  useApplyCartLinesChange,
  useSettings,
  BlockStack,
  InlineStack,
  Text,
  Button,
  Image,
} from "@shopify/ui-extensions-react/checkout";

export default reactExtension("purchase.checkout.block.render", () => <UpsellBlock />);

function UpsellBlock() {
  const applyCartLinesChange = useApplyCartLinesChange();
  const settings = useSettings();

  const products = settings?.upsellProducts || [
    {
      id: "gid://shopify/ProductVariant/14690975482219",
      title: ["WIN A LOBSTER FEAST PREPARED BY OUR FOUNDER!"],
      basePrice: 5000,
      currency: "USD",
      image: { url: "https://cdn.shopify.com/s/files/1/0007/9160/9459/files/mark1.png?v=1743682613" },
      description: [
        "🔥 Personalized Chef-Prepared Meal",
        "🔥 Intimate Dining at Your Location",
        "🔥 Gourmet Ingredient Selection",
      ],
      bgColor: "bg-fill-primary",
      textColor: "default",
      buttonColor: "critical",
    },
    {
      id: "gid://shopify/ProductVariant/14691184935275",
      title: ["EXTRA CONCIERGE SERVICE"],
      basePrice: 200,
      currency: "USD",
      image: { url: "https://cdn.shopify.com/s/files/1/0007/9160/9459/files/mark_1_1.png?v=1743681258" },
      description: [
        "🔥 1-on-1 Expert Help (cooking, prep, pairing)",
        "🔥 Instant VIP support (15/30-min slots)",
        "🔥 Free Mystery Gift",
      ],
      bgColor: "bg-fill-secondary",
      textColor: "default",
      buttonColor: "primary",
    },
  ];

  return (
    <BlockStack spacing="extraLoose" inlineAlignment="center">
      <Text size="large" emphasis="bold">
        🦞 Elevate Your Lobster Experience
      </Text>
      <InlineStack spacing="extraLoose" wrap>
        {products.map((product, index) => (
          <UpsellCard key={product.id} product={product} applyCartLinesChange={applyCartLinesChange} cardId={`upsell-card-${index}`} />
        ))}
      </InlineStack>
    </BlockStack>
  );
}

function UpsellCard({ product, applyCartLinesChange, cardId }) {
  async function handleAddProduct() {
    await applyCartLinesChange({
      type: "addCartLine",
      merchandiseId: product.id,
      quantity: 1,
    });
  }

  return (
    <BlockStack
      id={cardId} // 🔹 ID único para cada tarjeta
      border="base"
      padding="base"
      borderRadius="large"
      spacing="loose"
      background={product.bgColor}
      minInlineSize="fill"
    >
      <InlineStack blockAlignment="end" spacing="loose" maxBlockSize="fill">
        <Image
          source={product.image.url}
          description={product.title}
          borderRadius="large"
          fit
        />

        <BlockStack spacing="tight">
          <BlockStack spacing="none"> 
            {product.title.map((line, index) => (
              <Text key={index} size="medium" emphasis="bold" appearance="monochrome">
                {line}
              </Text>
            ))}
          </BlockStack>
          {product.description.map((item, index) => (
            <Text key={index} size="medium" appearance="info">
              {item}
            </Text>
          ))}
          <InlineStack spacing="loose" alignment="center" >
            <Button kind="secondary" onPress={handleAddProduct} appearance="critical">
              ADD FOR ${product.basePrice.toFixed(2)} {product.currency}
            </Button>
          </InlineStack>
        </BlockStack>
      </InlineStack>
    </BlockStack>
  );
}
